import React from 'react'

import { HighlightedHtml, Row, Wrapper } from 'Components/UI'
import { DateTime } from 'luxon'

import { BlogDetailRecordFragment } from 'GraphQL/DatoCMS/TypedDocuments'

import Authors from './authors'
import Rating from './rating'
import ShareBlock from './shareBlock'
import { Container, Content, Text, UpdatedAt } from './styles'

type Props = {
  data?: BlogDetailRecordFragment
}

// Fresh-content signal: show "Updated on" when the record was touched
// after the publish day. setZone keeps each timestamp's own offset so both
// the rendered day and the same-day comparison are identical in every
// runtime (server prerenders in UTC, browsers hydrate in the visitor's
// zone — local-zone math mismatches on hydration, React #418).
function getUpdatedOn(data?: BlogDetailRecordFragment) {
  if (!data?.updatedAt) return null

  const updated = DateTime.fromISO(data.updatedAt, { setZone: true })
  const published = data.date
    ? DateTime.fromISO(data.date, { setZone: true })
    : null

  if (published && updated.toISODate() === published.toISODate()) return null

  return updated.toFormat('MMMM dd, yyyy')
}

function Post({ data }: Props) {
  if (!data) return null

  const updatedOn = getUpdatedOn(data)

  return (
    <Container>
      {updatedOn && (
        <Wrapper>
          <UpdatedAt>
            Updated on <time dateTime={data.updatedAt}>{updatedOn}</time>
          </UpdatedAt>
        </Wrapper>
      )}

      <Wrapper>
        <Content>
          <ShareBlock absolute post={data} />

          <Text>
            <HighlightedHtml>{data.content}</HighlightedHtml>
          </Text>
        </Content>
      </Wrapper>

      <Wrapper>
        <Rating mt="32px" postId={data.id} />
      </Wrapper>

      <Wrapper mt={[16, 52]}>
        <Authors post={data} />
      </Wrapper>

      <Wrapper>
        <Row justifyCenter mt="32px" width={1}>
          {/*@ts-ignore*/}
          <ShareBlock post={data} />
        </Row>
      </Wrapper>
    </Container>
  )
}

export default Post
